import type { RouteObject } from "react-router"

export const auditRoutes: RouteObject[] = [
  {
    path: "audit",
    lazy: () => import("./audit-page").then((m) => ({ Component: m.AuditPage })),
  },
]
